<template>
  <div>
    <v-layout v-if="clients.length>0" wrap>
      <v-flex xs12>
        <v-layout pt-3 wrap>
          <v-flex xs12 text-center>
            <span
              style="
                padding-left: 50px;
                font-family: poppinssemibold;
                color: #e7ab5f;
                font-size: 38px;
              "
            >
              OUR CLIENTS
            </span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-space-around>
          <v-flex lg10>
            <v-layout wrap>
              <template v-for="(item, i) in clients">
                <v-flex pa-12 :key="i" xs12 md4 lg4 v-if="i < 12">
                  <v-hover v-slot:default="{ hover }" open-delay="200">
                    <v-card
                      to="/projects"
                      style="cursor: pointer"
                      :elevation="hover ? 24 : 6"
                      class="pa-1"
                    >
                      <v-img
                        contain
                        alt="Image couldnt load"
                        :src="baseURL+item.image"
                        height="150px"
                      >
                       <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="#FF2323"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                      </v-img>
                    </v-card>
                  </v-hover>
                </v-flex>
              </template>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout v-if="i >= 12" wrap>
          <v-flex text-center xs12>
            <v-btn class="white--text" color="#e7ab5f" to="/projects"
              >View All</v-btn
            >
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      i: 12,
      clients:[],
    };
  },
  mounted(){
    this.getClients();
  },
  methods: {
    // getImageURL(src) {
    //   var images = require.context("../../assets/");
    //   return images("./" + src);
    // },
     getClients() {
      axios({
        method: "GET",
        url: "/clients/list",
      })
        .then((response) => {
          if(response.data.status)
          this.clients = response.data.data;
        })
        .catch(() => {});
    },
  },
};
</script>